<script>
import lazyLoadComponent from '@router/lazyload-component'
import { orderStatusFilter, orderSourceFilter, orderPaymentMethodFilter, bookingStatusFilter, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import pageMixin from '@src/mixins/pagination'

export default {
  components: {
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    orderStatusFilter,
    orderSourceFilter,
    orderPaymentMethodFilter,
    formatDate,
    bookingStatusFilter,
    paymentStatusMapFilter,
  },
  mixins: [pageMixin],
  props: {
    memberInfoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      componentKey: 0,
      loadedOrders: [],
      tryingToGetOrder: false,
      drawerVisible: false,
      drawerOrderData: '',
      filterData: {
        order_by: 'created_at',
        order: 'desc',
      },
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build' ,
    }
  },
  watch: {
    currentPage: {
      handler: 'tryToSearchOrder',
      immediate: true,
    },
  },
  methods: {
    calcRowClassName({ row }) {
      const orderStatus = row.status
      const orderUsedStatus = row.groupSize / row.usedSize

      if (orderStatus === 0) return 'order--canceled'
      if (orderUsedStatus === 1) return 'order--used'
    },
    async tryToGetOrder(row) {
      this.tryingToGetOrder = true
      this.drawerOrderData = await this.$store.dispatch('order/fetchSingle', row.id)
      this.tryingToGetOrder = false
      this.drawerVisible = true
    },
    async tryToSearchOrder() {
      const { items, total } = await this.$store.dispatch(
        'order/fetchList',
        Object.assign(
          {
            memberId: this.memberInfoId,
            paymentMethod: 'All',
            order_by: this.filterData.order_by,
            order: this.filterData.order,
            types: ['cosmetic']
          },
          this.pageQuery
        )
      )
      this.loadedOrders = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
    sortChange({ column, prop, order }) {
      if (order) {
        this.filterData.order_by = prop
        this.filterData.order = order === 'ascending' ? 'asc' : 'desc'
        this.currentPage = 1
        this.tryToSearchOrder()
      }
      // console.log(column, prop, order)
    },
  },
}
</script>

<template>
  <div>
    <div class="el-table-wrapper pb-3">
      <el-table
        v-loading.fullscreen.lock="tryingToGetOrder"
        element-loading-text="取得訂單資訊中"
        :data="loadedOrders"
        :default-sort="{ prop: 'created', order: 'descending' }"
        :row-class-name="calcRowClassName"
        class="isStyleBgDark"
        @row-click="tryToGetOrder"
        @sort-change="sortChange"
      >
        <el-table-column v-slot="{ row }" prop="startDate" min-width="200" label="服務項目 / 服務時間" sortable="custom">
          <div>{{ row.productName }} {{ row.params[0].title }}</div>
          <div class="fs-sm text-secondary-light">{{ row.date | formatDate }} {{ row.time }}</div>
          <div class="fs-sm text-secondary-light">${{ row.allActualPayTotal }} - {{row.paymentMethod | orderPaymentMethodFilter}}</div>
        </el-table-column>
        <el-table-column v-slot="{ row }" prop="startDate" min-width="200" label="預約狀態" sortable="custom">
          <BaseStateLabel state="info" text>{{ row.status | bookingStatusFilter('text') }}</BaseStateLabel>
          <div class="fs-sm text-secondary-light">{{$t('reserve.CLIENT')}}：{{row.pet.name}}</div>
        </el-table-column>
      </el-table>
    </div>
    <BasePagination ref="pagination" :current-page.sync="currentPage" :display-column="true"/>
    <el-drawer
      ref="orderFormEdit"
      class="only-close"
      :class="{ 'appStyle': appStyle }" 
      :visible.sync="drawerVisible"
      append-to-body
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <ReservationOrderDetail 
        ref="orderDetail" 
        order-type="reservation"
        :default-value.sync="drawerOrderData" 
        @update="tryToSearchOrder" 
      />
    </el-drawer>
  </div>
</template>
